module.exports = __webpack_public_path__ + "static/media/person-carry.52586738.svg";